import axios from "axios";
import { API_URL } from "../../config";

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  // Never let a request hang forever (e.g. unreachable backend). Without a
  // timeout, a dead API leaves callers stuck on "Loading..." indefinitely.
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Add request interceptor for authentication and logging
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // Debug token usage
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for handling auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle authentication errors
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // Only redirect if not already on login page
        if (!window.location.pathname.includes("/login")) {
          // Use timeout to prevent endless redirect loops
          setTimeout(() => {
            window.location.href = "/login";
          }, 100);
        }
      }

    } else {
    }
    return Promise.reject(error);
  }
);

export default api;
